export class CalcUtils {
    static sum(a: number, b: number): number {
        return a + b
    }

    static rest(a: number, b: number): number {
        return a - b
    }

    static mult(a: number, b: number): number {
        return a * b
    }

    static div(a: number, b: number): number {
        return a / b
    }
}
